<!-- 合作商管理 -->
<template>
  <div class="category-management">
    <page-title title="筛选">
      <el-row class="category-management__filter-header" :gutter="20">
        <el-col :xl="4" :span="6">
          <span>合作商名称：</span>
          <el-input v-model="filter.systemName" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>合作商手机号：</span>
          <el-input v-model="filter.phone" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
          <el-button @click="openDialog('add')"> 新建合作商</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="category-management__body">
        <el-table v-loading="loading" :data="tableData" style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }">
          <el-table-column prop="id" label="合作商ID"></el-table-column>
          <el-table-column prop="systemName" label="合作商名称"></el-table-column>
          <el-table-column prop="contactUser" label="联系人"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="price" label="登记单价"></el-table-column>
          <el-table-column prop="remainLimit" label="剩余额度">
            <template slot-scope="scope">
              {{scope.row.isLimit == 1 ? '不限额度' : scope.row.remainLimit}}
            </template>
          </el-table-column>
          <el-table-column prop="creditLimit" label="授信额度">
            <template slot-scope="scope">
              {{scope.row.isLimit == 1 ? '不限额度' : scope.row.creditLimit}}
            </template>
          </el-table-column>
          <el-table-column prop="usedLimit" label="已用额度"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button class="edit" type="text" @click="toDetail(scope.row)">授信管理</el-button>
              <el-button class="edit" type="text" @click="openDialog('edit', scope.row)">编辑</el-button>
              <el-button class="edit" type="text" @click="deleteRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination :total="total" :current-page.sync="currentPage" :page-size.sync="pageSize"
          @size-change="getList"></cus-pagination>
      </div>
    </page-title>

    <!-- 新增、修改 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogMode == 'add' ? '新建合作商' :  '编辑合作商'"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="40%"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="formRef"
          label-width="140px"
        >
          <el-form-item label="合作商名称" prop="systemName">
              <el-input v-model.trim="form.systemName" placeholder="请输入" maxlength="30" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contactUser">
              <el-input v-model.trim="form.contactUser" placeholder="请输入" maxlength="10" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
              <el-input v-model.trim="form.phone" placeholder="请输入"  maxlength="11" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="登记单价（元）" prop="price">
              <el-input-number style="width: 100%;" :precision="2" :controls="false" v-model="form.price" placeholder="请输入" :min="0.01" :max="999"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button :loading="loading" type="primary" @click="handleSubmit">确定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import {
  getCategoryPageList,
  categoryAdd,
  categoryEdit,
  upAndDown,
  categoryDel,
} from "@/api/page";

import {
  getPartnerList,
  addPartner,
  eidtPartner,
  delPartner
} from "@/api/partner";


import { Message } from "element-ui";
import { scope } from "@/config/config";
export default {
  components: {
    PageTitle,
    CusPagination,
  },
  data() {
    return {
      form: {
        systemName: '',
        contactUser: '',
        phone: '',
        price: 0,
      },
      rules: {
        systemName: [
            { required: true, message: '请输入合作商名称', trigger: 'blur' },
        ],
        contactUser: [
            { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        price: [
            { required: true, message: '请输入登记单价', trigger: 'blur' },
        ],
      },
      apiEnd: false,
      loading: true,
      filter: {
        systemName: "",
        phone: '',
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogMode: "add", // 默认模式
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    toDetail(row){
        this.$router.push({
            path: '/partnerDetail',
            query: {
                id: row.id,
            }
        })
    },
    handleSubmit() {
      let apis = {
        add: addPartner,
        edit: eidtPartner,
      }
      this.$refs.formRef.validate( (valid) => {
        if (valid) {

          // 添加手机号格式验证
          const phoneRegex = /^1[3-9]\d{9}$/;
          if (!phoneRegex.test(this.form.phone)) {
            this.$message.warning("请输入正确的手机号格式");
            return;
          }

          let obj = this.form
          let api = apis[this.dialogMode]
          this.$ajax.post(api, obj).then( res => {
            let data = res.data
            if (data.code == 200){
              this.handleClose()
              this.getList()
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    handleClose () {
        this.resetForm();
    },
    resetForm() {
      this.form = {
          systemName: '',
          contactUser: '',
          phone: '',
          price: 0,
      };
      this.$refs.formRef.clearValidate()
      this.dialogVisible = false
    },
    async getList() {
      this.loading = true;
      const params = {
        pageSize: this.pageSize,
        pageOn: this.currentPage,
        systemName: this.filter.systemName,
        phone: this.filter.phone,
      };

      const { data } = await this.$ajax.get(getPartnerList, params);
      this.tableData = data?.data?.rows || [];
      this.total = data?.data?.total || 0;
      this.loading = false;
    },
    search() {
      this.getList();
    },
    reset() {
      this.filter.systemName = "";
      this.filter.phone = "";
      this.getList();
    },
    edit(row) {
      console.log("Editing row", row);
    },
    async delApi(id) {
      const res = await this.$ajax.get(delPartner, {id: id});
      const { code, msg } = res?.data ?? {};
      console.log(code);
      if (code == 200) {
        Message.success(msg);
        this.getList();
      }
    },
    /**
     * 删除
     */
    deleteRow(row) {
      this.$confirm("确认删除该项吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.delApi(row.id);
        })
        .catch(() => {
          Message.info("删除已取消");
        });
    },
    handlePageChange(page) {
      console.log("Page changed to", page);
    },
    openDialog(mode, data = {}) {
      this.dialogMode = mode
      if(mode == 'edit') {
        this.form = { ...data }
      }
      this.dialogVisible = true
    },
    /**
     * 新增接口
     */
    // async addApi(params) {
    //   this.apiEnd = true;
    //   const { data } = await this.$ajax.post(categoryAdd, params);
    //   if (data.code === 200) {
    //     this.apiEnd = false;
    //     this.dialogVisible = false;
    //     this.getList();
    //     Message.success(data.msg);
    //   } else if (data.code === 500) {
    //     this.$message.error(data.msg);
    //     this.apiEnd = false;
    //   }
    // },
    /**
     * 编辑接口
     */
    async editApi(params,row) {
      this.apiEnd = true;
      const { data } = await this.$ajax.put(categoryEdit, params);
      if (data.code === 200) {
        this.apiEnd = false;
        this.dialogVisible = false;
        this.getList();
        Message.success(data.msg);
      } else if (data.code === 500) {
        this.$message.error(data.msg);
        this.apiEnd = false;
        if(row){   //编辑失败时，将状态还原  开关状态
          row.isHome = !row.isHome
        }
      }
    },
    // handleSwitchChange(row, index) {
    //   const { id, isHome, isPicture } = row;
    //   const params = {
    //     id,
    //     isHome,
    //   };
    //   const params2 = {
    //     id,
    //     isPicture,
    //   };
    //   this.editApi(index === 1 ? params : params2,row);
    // },
    /**
     * 上移下移
     */
    // async upAndDownApi(data) {
    //   const { data: res } = await this.$ajax.get(upAndDown, data);
    //   if (res.code === 200) {
    //     this.getList();
    //   }
    // },
    /**
     * 移动
     */
    // move(type, row) {
    //   const { id } = row;
    //   const currentIndex = this.tableData.findIndex(item => item.id === id);
    //   let targetSort;

    //   if (type === "up" && currentIndex > 0) {
    //     targetSort = this.tableData[currentIndex - 1].sort;
    //   } else if (type === "down" && currentIndex < this.tableData.length - 1) {
    //     targetSort = this.tableData[currentIndex + 1].sort;
    //   }

    //   this.upAndDownApi({ id, sort: targetSort });
    // },
    // handleConfirm(formData) {
    //   let that = this;
    //   if (this.dialogMode === "add") {
    //     that.addApi(formData);
    //   } else {
    //     that.editApi(formData);
    //     console.log("编辑数据:", formData);
    //   }
    // },
  },
  created() {
    const { query } = this.$route;
    if (JSON.stringify(query) !== "{}") {
      this.filter = Object.assign(this.filter, query);
    }
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__body {
    .edit {
      color: #005bff;
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    .el-switch__label {
      color: #333333;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
}
</style>
